import {FieldRecord} from '../../../lib/fieldOptions';

export const getDiscoverSortOptions = (): FieldRecord[] => [
  {value: 'newest', label: 'Newest'},
  {value: 'launch_date', label: 'Ready to launch'},
  {value: 'game_expensive', label: 'The most expensive games'},
  {value: 'game_cheap', label: 'Least investment'},
  {value: 'most_funded', label: 'Most funded'}
];
